<script setup lang="ts">
import { RouterView } from "vue-router";
import { useLoadingStore } from "./stores/useLoadingStore";
import { useAuth } from "./composables/useAuth";
import LoadingBar from "./components/common/LoadingBar.vue";
import InactivityAlert from "./components/common/InactivityAlert.vue";
import { onMounted, onUnmounted } from "vue";
import { useTheme } from "./composables/useTheme";
import { useShipmentUpdates } from "./composables/useShipmentUpdates";
import { useBuildVersion } from "./composables/useBuildVersion";
import ShipmentAlert from "./components/alerts/ShipmentAlert.vue";
// import UsersnapProvider from "./components/UsersnapProvider.vue";

// Inicializar el tema
useTheme();

const loadingStore = useLoadingStore();
const { showInactivityAlert, countdown, cancelLogoutCountdown, handleLogout } =
  useAuth();

// Inicializar el listener de actualizaciones de shipments
const { setupListener, cleanup } = useShipmentUpdates();

// Sistema de detección de actualización de build
const { needsRefresh, refreshApp } = useBuildVersion();

// Verificar si hay una actualización disponible y actualizarla automáticamente
onMounted(() => {
  setupListener();
  
  // Si se detecta una nueva versión, actualizar automáticamente
  if (needsRefresh.value) {
    refreshApp();
  }
});

onUnmounted(() => {
  cleanup();
});
</script>

<template>
  <LoadingBar :is-loading="loadingStore.isLoading" />
  <InactivityAlert
    :show="showInactivityAlert"
    :countdown="countdown"
    @stay="cancelLogoutCountdown"
    @logout="handleLogout"
  />
  <ShipmentAlert />
  <RouterView />

</template>

  <style>
    /* Estilo base para scrollbars */
    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    ::-webkit-scrollbar-track {
      background: transparent;
    }

    /* Light mode scrollbar */
    ::-webkit-scrollbar-thumb {
      background-color: #cbd5e1;
      border-radius: 4px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background-color: #94a3b8;
    }

    /* Dark mode scrollbar */
    :root.dark ::-webkit-scrollbar-thumb {
      background-color: #475569;
      border-radius: 4px;
    }

    :root.dark ::-webkit-scrollbar-thumb:hover {
      background-color: #64748b;
    }

    /* Firefox scrollbar styles */
    * {
      scrollbar-width: thin;
      scrollbar-color: #cbd5e1 transparent;
    }

    :root.dark * {
      scrollbar-color: #475569 transparent;
    }
  </style>
